const Timer = {
    active: false,
    interval: null,

    callback: null,

    init: (config, callback) => {
        window.Timer = {};
        window.Timer.callback = callback;
        Timer.callback = callback;
        const customerIdTimeOut = (config.defaultValues.customerExpiredTimeInMinute || 15) * 60000;
        getStorage().setItem("Timer.customerIdTimeOut", customerIdTimeOut);
        const idleTimeOut = (config.defaultValues.idleTimeInMinute || 15) * 60000;
        getStorage().setItem("Timer.idleTimeOut", idleTimeOut);
        Timer.checkTimeOut();
    },

    checkTimeOut: () => {
        const currentTime = new Date().getTime();
        const customerIdStartTime = getStorage().getItem("Timer.customerIdStartTime");
        const customerIdTimeOut = getStorage().getItem("Timer.customerIdTimeOut");
        const customerId = getStorage().getItem("customerId");
        if (customerIdStartTime && customerIdTimeOut) {
            if ((currentTime - customerIdStartTime) >= customerIdTimeOut) {
                Timer.onExpire();
                return;
            }
        } else if (!customerIdStartTime && customerId) {
            Timer.onExpire();
            return;
        }

        const idleStartTime = getStorage().getItem("Timer.idleStartTime");
        const idleTimeOut = getStorage().getItem("Timer.idleTimeOut");
        if (idleStartTime && idleTimeOut && customerId) {
            if ((currentTime - idleStartTime) >= idleTimeOut) {
                Timer.onExpire();
            }
        }
    },

    startCustomerIdTimerExpiration: () => {
        getStorage().setItem("Timer.customerIdStartTime", new Date().getTime());
        Timer.startIdleTimerExpiration();
    },

    startIdleTimerExpiration: () => {
        if (!Timer.active) {
            Timer.active = true;
            Timer.interval = window.setInterval(Timer.checkTimeOut, 1000);
        }

        getStorage().setItem("Timer.idleStartTime", new Date().getTime());
    },

    resetIdleStartTime: () => {
        Timer.clearIdleTimer();
        Timer.startIdleTimerExpiration();
    },

    clearCustomerIdExpirationTimer: () => {
        getStorage().removeItem("Timer.customerIdStartTime");
    },

    clearIdleTimer: () => {
        getStorage().removeItem("Timer.idleStartTime");
    },

    clearAll: () => {
        Timer.active = false;
        clearInterval(Timer.interval);

        Timer.clearCustomerIdExpirationTimer();
        Timer.clearIdleTimer();
    },

    onExpire: () => {
        if (window.opener && window.opener.Timer) {
            const callback = window.opener.Timer.callback;
            if (typeof callback === "function") {
                callback();
            }
        } else if (window.Timer) {
            const callback = window.Timer.callback;
            if (typeof callback === "function") {
                callback();
            }
        } else if (Timer.callback) {
            const callback = Timer.callback;
            if (typeof callback === "function") {
                callback();
            }
        }
        Timer.clearAll();
    },
};

const getStorage = () => localStorage || {
    getItem: () => undefined,
    setItem: () => {},
    removeItem: () => {},
};

document.onmousemove = Timer.resetIdleStartTime;
document.onkeypress = Timer.resetIdleStartTime;

export { Timer };
